// @flow

import React from 'react';
import { isPlainObject } from 'lodash';

import Help from 'app/get-help/components/blocks/Help/Help';
import { base } from 'app/get-help/utils/tree';

import type { NodeDefinition } from 'app/get-help/utils/tree/types';
import { type HelpNodeOptions } from 'app/get-help/components/blocks/Help/types';

const help = (
  options: HelpNodeOptions = {
    contact: [],
  }
): NodeDefinition => {
  const hasContactFields =
    Array.isArray(options.contact) && options.contact.length > 0;

  const node = base({
    id: 'help',
    isRequired: hasContactFields,
    isDataValid: data => {
      if (!hasContactFields) {
        return true;
      }
      const contact = options.contact || []; // flow
      const contactData = isPlainObject(data) ? data : {}; // flow
      return !contact.some(
        ({ id, isRequired }) => isRequired && !contactData[id]
      );
    },
    parseData: data => {
      if (!isPlainObject(data)) {
        return null;
      }

      // skip feedback via querystring
      if (typeof data.contact === 'string') {
        data.contact = data.contact === 'yes';
      }

      return data;
    },
    render: props => <Help {...props} {...options} />,
    // We could potentially allow export to return an array and flatten here instead of in backend, but we'd risk id collisions.
    export: data => {
      const result = {
        id: node.id,
        data,
        formatted: [],
      };

      if (hasContactFields) {
        const contact = options.contact || []; // flow
        const contactData = isPlainObject(data) ? data : {}; // flow

        contact.forEach(({ id, label, type }) => {
          const itemData = contactData[id];
          if (itemData) {
            const formattedItemData =
              type === 'image' && typeof itemData === 'string'
                ? itemData.replace(/\s+/g, '<br />')
                : null;
            result.formatted.push({
              id,
              label,
              data: itemData,
              formatted: formattedItemData,
            });
          }
        }, []);
      }

      return result;
    },
  });

  return node;
};

export default help;
